export enum AppEventTypes {
  load = 'load',
  unload = 'unload',
  show = 'show',
  hide = 'hide',
  changeAttendance = 'changeAttendance',
  redirectRouteApp = 'redirectRouteApp',
  selectedAttendanceUpdate = 'selectedAttendanceUpdate',
  inviteForConversation = 'inviteForConversation',
  startWhatsappConversation = 'startWhatsappConversation',
  updateEmailData = 'updateEmailData',
  messageToAnotherApp = 'messageToAnotherApp',
  updatePhoneData = 'updatePhoneData',
  changeTheme = 'changeTheme',
  canQuoteUpdate = 'canQuoteUpdate'
}
